import React, { useState } from "react";
import SEO from "../../components/SEO";
import { Plus, Minus, MapPin, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import img64 from "../../assets/img64.jpg";
import img65 from "../../assets/img65.jpg";
import img66 from "../../assets/img66.jpg";
import img67 from "../../assets/img67.jpg";
import img68 from "../../assets/img68.png";
import img69 from "../../assets/img69.jpg";
import img70 from "../../assets/img70.jpg";
import img71 from "../../assets/img71.jpg";
import img102 from "../../assets/Img102.jpg";
import img103 from "../../assets/Img103.jpg";


const benefits = [
  {
    title: "Continuous Learning and Development - Growth and success",
    content:
      "We invest in your professional development through regular training sessions, workshops, and courses. Stay ahead of industry trends and continuously enhance your skills with us.",
  },
  {
    title: "Uncapped Commissions",
    content:
      "There’s no limit to what you can earn. With our uncapped commission model, your income potential grows as you expand your client base and close more deals.",
  },
  {
    title: "Extensive Client Base",
    content:
      "einsured.ca has a broad and diverse client base, giving you ample opportunities to grow your portfolio. Our strong reputation in the market makes it easier for you to build trust and long-lasting relationships with clients.",
  },
  {
    title: "Flexible work hours",
    content:
      "We understand the importance of maintaining a healthy work-life balance. We offer flexible working arrangements that allow you to manage your time effectively, ensuring you can perform at your best both professionally and personally.",
  },
  {
    title: "Cutting-Edge Technology",
    content:
      "Stay ahead of the curve with access to the latest industry tools and technologies. Our advanced systems streamline your work, allowing you to focus on what you do best—helping clients secure their financial future.",
  },
  {
    title: "Partnerships with Top Insurance Companies",
    content:
      "At einsured.ca, you’ll benefit from our strong partnerships with leading insurance providers. This gives you access to a wide range of products and solutions, making it easier to meet your clients’ needs and close deals.",
  },
];

const OurTeam = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleToggle = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
  <>
    <SEO
      title="Meet Our Insurance Experts | einsured.ca Canada"
      description="Meet the experienced einsured.ca team of licensed insurance advisors committed to providing expert guidance and customized insurance solutions across Canada."
    />

    {/* HERO SECTION */}
      <section
        className="relative min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] lg:h-[80vh] flex items-center bg-cover bg-center"
        style={{ backgroundImage: `url(${img64})` }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 w-full container px-4 sm:px-8 md:px-24">
          <div className="max-w-3xl text-white text-center sm:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
              Meet Our Team
            </h1>
            <p className="text-base sm:text-lg md:text-xl leading-relaxed">
              Your Trusted Team at einsured.ca - Guiding You to Financial
              Security and Peace of Mind
            </p>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE EINSURED */}
      <section
        className="py-16 sm:py-16 px-4 sm:px-6 md:px-24"
        style={{ backgroundColor: "#edf4ff", color: "#3b5180" }}
      >
        <div className="container text-center px-2">
          <h2 className="text-[#49628b] text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            Why Choose einsured.ca for Your Career?
          </h2>
          <p
            className="text-base sm:text-lg"
            style={{ color: "#5f6f8f" }}
          >
            At einsured.ca, we are committed to your success as a Life and
            Health Insurance Advisor. Here’s why joining our team could be the
            best career move you make:
          </p>
        </div>

        <div className="container mt-12 grid gap-12 md:gap-16 md:grid-cols-2 items-start">
          <div className="bg-white rounded-3xl shadow-sm p-6 sm:p-10 flex justify-center">
            <img
              src={img65}
              alt="einsured.ca advisor character"
              className="max-h-[400px] w-auto object-contain"
            />
          </div>

          <div className="flex flex-col justify-center">
            <div
              className="border border-[#d7e3ff] rounded-md overflow-hidden"
              style={{ backgroundColor: "#edf4ff" }}
            >
              {benefits.map((item, index) => {
                const isOpen = index === activeIndex;
                return (
                  <div
                    key={item.title}
                    className="border-t border-[#d7e3ff] first:border-t-0"
                  >
                    <button
                      type="button"
                      onClick={() => handleToggle(index)}
                      className="w-full flex items-center justify-between gap-3 sm:gap-4 px-4 sm:px-6 py-3 sm:py-4 text-left"
                    >
                      <span className="font-semibold text-[#49628b] text-sm sm:text-lg pr-4">
                        {item.title}
                      </span>
                      {isOpen ? (
                        <Minus
                          className="w-5 h-5 text-[#49628b] flex-shrink-0"
                          aria-hidden="true"
                        />
                      ) : (
                        <Plus
                          className="w-5 h-5 text-[#49628b] flex-shrink-0"
                          aria-hidden="true"
                        />
                      )}
                    </button>

                    {isOpen && (
                      <div
                        className="px-4 sm:px-6 pb-4 text-sm sm:text-base"
                        style={{ color: "#5f6f8f", backgroundColor: "#edf4ff" }}
                      >
                        {item.content}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="container mt-12 text-center px-2">
          <p className="text-base" style={{ color: "#5f6f8f" }}>
            We are committed to your professional development. Through ongoing
            training and skill enhancement programs, you’ll stay ahead of
            industry trends and continuously improve your expertise.
          </p>

        </div>
      </section>

      {/* JOB POSITION */}
<section
  className="py-16 sm:py-20 px-4 sm:px-6 md:px-24"
  style={{ backgroundColor: "#f5f9ff", color: "#3b5180" }}
>
<p
  className="mt-6 text-sm sm:text-base font-medium text-center container"
  style={{ color: "#5f6f8f" }}
>
  Careers with einsured.ca
</p>

<h3
  className="mt-2 text-2xl sm:text-3xl font-bold text-center container"
  style={{ color: "#3b5180" }}
>
  Featured Opportunities
</h3>

  <div className="container grid gap-10 md:grid-cols-2 items-start bg-white rounded-3xl shadow-sm p-6 sm:p-10 lg:p-12 mt-8">
    {/* Left Box */}
    <div
      className="bg-[#f5f7fc] p-6 sm:p-8 rounded-2xl flex flex-col justify-center items-start"
      style={{ color: "#3b5180" }}
    >
      <h3 className="text-2xl font-semibold mb-6 text-black">
        Insurance Advisor - Life and Health
      </h3>
      <div className="flex items-center gap-3 bg-[#f1f3f9] px-4 sm:px-5 py-3 rounded-xl w-full sm:w-auto">
        <MapPin className="w-5 h-5 sm:w-7 sm:h-7 text-[#00a2ff]" />
        <p className="font-semibold text-sm sm:text-lg text-[#49628b]">
          Canada
        </p>
      </div>
    </div>

    {/* Right Box */}
    <div className="text-[#49628b]">
      <h4 className="text-xl font-bold mb-3 text-black">
        Position Overview:
      </h4>
      <p className="text-[#5f6f8f] mb-6 text-sm sm:text-base">
        As a{" "}
        <span className="font-semibold text-[#20a7df]">
          Life &amp; Health Insurance Advisor
        </span>
        , you will play a pivotal role in helping clients make informed
        decisions about their insurance needs. You will be responsible for
        advising on life and health insurance products, customizing plans based
        on individual client requirements, and providing exceptional customer
        service. Your primary goal is to help clients protect their loved ones
        and achieve financial security.
      </p>

      <h4 className="text-xl font-bold mb-3 text-black">
        Key Responsibilities:
      </h4>
      <ul className="list-disc pl-5 sm:pl-6 text-[#5f6f8f] space-y-2 text-sm sm:text-base">
        <li>
          Consult with clients to understand their life and health insurance
          needs and objectives
        </li>
        <li>
          Provide professional advice on a range of life and health insurance
          products, including life, critical illness, disability, and health
          coverage
        </li>
        <li>
          Develop personalized insurance plans tailored to clients’ specific
          needs
        </li>
        <li>
          Maintain strong relationships with clients by offering ongoing support
          and insurance reviews
        </li>
        <li>
          Conduct needs analysis and risk assessments to recommend suitable
          coverage options
        </li>
        <li>
          Stay up-to-date on industry trends, insurance products, and regulatory
          changes
        </li>
        <li>
          Assist clients through the claims process, ensuring efficient handling
          of their concerns
        </li>
        <li>
          Achieve sales and performance targets through prospecting,
          networking, and referrals
        </li>
        <li>
          Adhere to compliance and ethical standards in all interactions with
          clients
        </li>
      </ul>
    </div>
  </div>

  {/* Join Button */}
  <div className="flex justify-center mt-10">
    <a
      href="/our-team"
      className="bg-[#20a7df] hover:bg-[#008ee0] text-white font-semibold px-10 py-3 rounded-lg shadow-md transition w-full sm:w-auto text-center"
    >
      Join now
    </a>
  </div>
</section>

{/* OUR TEAM CARDS SECTION */}
<section
  className="py-16 sm:py-2 px-4 sm:px-6 md:px-24"
  style={{ backgroundColor: "#f5f9ff" }}
>
  <div className="container">
    <div className="text-center mb-12 px-2">
      <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b]">
        Our Team
      </h2>
      <p className="mt-6 font-bold text-[#5f6f8f] text-sm sm:text-base">
        Meet our dedicated professionals!
      </p>
    </div>

    {/* Cards grid */}
    <div className="grid gap-10 lg:gap-12 md:grid-cols-2">
      {/* AMAN */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img66}
            alt="Aman Ahuja"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/our-team/aman"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Aman Ahuja
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">
            CEO &amp; Sr. Insurance Broker
          </p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+14168166100"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 816-6100
            </a>
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 100
            </a>
            <a
              href="mailto:aman@einsured.ca"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>aman@einsured.ca</span>
            </a>
          </div>
        </div>
      </div>

      {/* SUNAINA */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img67}
            alt="Sunaina Ahuja"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
         <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/our-team/sunaina"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Sunaina Ahuja
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">
            COO &amp; Insurance Broker
          </p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+14165649000"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 564-9000
            </a>
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 101
            </a>
            <a
              href="mailto:sunaina@einsured.ca"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>sunaina@einsured.ca</span>
            </a>
          </div>
        </div>
      </div>

      {/* AARTI */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img68}
            alt="Aarti"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/our-team/aarti"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Aarti
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">Insurance Broker</p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+14169901800"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 990-1800
            </a>
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 104
            </a>
            <a
              href="mailto:acl.13n@gmail.com"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>acl.13n@gmail.com</span>
            </a>
          </div>
        </div>
      </div>

      {/* SHIKHA */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img69}
            alt="Shikha Ahuja"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/our-team/shikha"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Shikha Ahuja
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">Insurance Broker</p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+16475322101"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (647) 532-2101
            </a>
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 102
            </a>
            <a
              href="mailto:shikha@einsured.ca"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>shikha@einsured.ca</span>
            </a>
          </div>
        </div>
      </div>

      {/* GURKIRAN */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img70}
            alt="Gurkiran Kaur"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/our-team/gurkiran"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Gurkiran Kaur
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">Insurance Broker</p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+14168400128"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (416) 840-0128 ext. 103
            </a>
            <a
              href="mailto:gurkiran@einsured.ca"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>gurkiran@einsured.ca</span>
            </a>
          </div>
        </div>
      </div>

      {/* SAMRIDHI */}
      <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
        <div className="flex-shrink-0">
          <img
            loading="lazy"
            src={img71}
            alt="Samridhi Sharma"
            className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover"
          />
        </div>
        <div className="flex-1 text-white">
          <div className="flex justify-center sm:justify-start mb-6">
  <Link
    to="/our-team/samridhi"
    className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors"
  >
    Samridhi Sharma
  </Link>
</div>

          <p className="text-sm sm:text-base mb-4">Insurance Broker</p>
          <div className="space-y-3 w-full">
            <a
              href="tel:+17807778950"
              className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full"
            >
              (780) 777-8950
            </a>
            <a
              href="mailto:getinsured.sam@gmail.com"
              className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"
            >
              <Mail className="w-4 h-4" />
              <span>getinsured.sam@gmail.com</span>
            </a>
          </div>

        </div>

      </div>
           {/* EKTA */}
            <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
              <div className="flex-shrink-0">
                <img src={img102} alt="Ekta" className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover" loading="lazy" />
              </div>
              <div className="flex-1 text-white">
                <div className="flex justify-center sm:justify-start mb-6">
                  <Link to="/our-team/ekta" className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors">Ekta</Link>
                </div>
                <p className="text-sm sm:text-base mb-4">Insurance Broker</p>
                <div className="space-y-3 w-full">
                  <a href="tel:+14162575700" className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full">(416) 257-5700</a>
                  <a href="mailto:insurewithekta@gmail.com" className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full"><Mail className="w-4 h-4" /><span>insurewithekta@gmail.com</span></a>
                  </div>
              </div>
            </div>

            {/* YASHRAJ */}
            <div className="bg-[#12a5dd] rounded-[32px] shadow-[0_25px_40px_rgba(0,0,0,0.15)] px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center sm:items-stretch gap-8">
              <div className="flex-shrink-0">
                <img src={img103} alt="Yashraj Kharbanda" className="w-36 h-44 sm:w-40 sm:h-48 rounded-[24px] object-cover" loading="lazy" />
              </div>
              <div className="flex-1 text-white">
                <div className="flex justify-center sm:justify-start mb-6">
                  <Link to="/our-team/yashraj" className="bg-[#3b4f80] px-6 sm:px-8 py-2 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)] text-base sm:text-lg font-semibold text-center hover:bg-[#314069] transition-colors">Yashraj Kharbanda</Link>
                </div>
                <p className="text-sm sm:text-base mb-4">Insurance Broker</p>
                <div className="space-y-3 w-full">
                  <a href="tel:+16476791829" className="block bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 text-center w-full" >(647) 679-1829</a>
                  <a href="mailto:kharbandayashraj1@gmail.com" className="flex items-center justify-center gap-2 bg-white text-[#49628b] text-sm sm:text-base font-medium rounded-xl px-5 py-3 break-all sm:break-normal w-full" ><Mail className="w-4 h-4" /><span>kharbandayashraj1@gmail.com</span></a>
                </div>
              </div>
            </div>
    </div>
  </div>
</section>

    </>
  );
};

export default OurTeam;
